// extracted by mini-css-extract-plugin
export default {"input":"Cryptocurrencies_input__-6BjK"};